import React from "react";

const IconEye = ({ color = "#e31c19" }) => {
  return (
    <svg
      id="UI_icon_show_light"
      data-name="UI icon/show/light"
      xmlns="http://www.w3.org/2000/svg"
      width="13.469"
      height="9.707"
      viewBox="0 0 13.469 9.707"
    >
      <path
        id="Oval_Stroke_"
        data-name="Oval (Stroke)"
        d="M6.734,9.707a6.821,6.821,0,0,1-4.3-1.519A9.488,9.488,0,0,1,.218,5.639a1.526,1.526,0,0,1,0-1.572A9.491,9.491,0,0,1,2.429,1.519a6.862,6.862,0,0,1,8.61,0,9.5,9.5,0,0,1,2.211,2.549,1.526,1.526,0,0,1,0,1.572,9.5,9.5,0,0,1-2.211,2.549A6.821,6.821,0,0,1,6.734,9.707Zm0-8.321A6.37,6.37,0,0,0,1.407,4.781a.143.143,0,0,0-.022.073.139.139,0,0,0,.022.072A6.368,6.368,0,0,0,6.734,8.32a6.368,6.368,0,0,0,5.327-3.394.137.137,0,0,0,.022-.072.14.14,0,0,0-.022-.073A6.37,6.37,0,0,0,6.734,1.387Z"
        transform="translate(0 0)"
        fill={color}
      />
      <path
        id="Ellipse_138_Stroke_"
        data-name="Ellipse 138 (Stroke)"
        d="M2,4A2,2,0,1,1,4,2,2,2,0,0,1,2,4ZM2,1.333A.667.667,0,1,0,2.666,2,.667.667,0,0,0,2,1.333Z"
        transform="translate(4.414 2.533)"
        fill={color}
      />
    </svg>
  );
};

export default IconEye;
